// extracted by mini-css-extract-plugin
export default {"info":"ReactorTileInfo_info__37oB5","container":"ReactorTileInfo_container__PiDyv"};